// extracted by mini-css-extract-plugin
export default {"root":"safe-area-blur_root__4gHJz","layer":"safe-area-blur_layer__AGUs7"};